import { HiOutlineChevronRight } from 'react-icons/hi';

import { type ContinueButton } from '@core/blocks/edu-flow-2/components/NavigationButtons/ContinueButton/continueButtonsTypeDictionary';

import styles from './SubmitButton.module.css';

const SubmitButton: ContinueButton = ({ text, disabled, buttonRef, onClick = () => {} }) => (
  <>
    <button
      type="button"
      data-testid="continue"
      className={styles.submitButton}
      disabled={disabled}
      onClick={onClick}
      ref={buttonRef}
    >
      {text}
      <HiOutlineChevronRight />
    </button>
  </>
);

export default SubmitButton;
